import { render } from "./PopupRemind.vue?vue&type=template&id=67f8c4ff&scoped=true"
import script from "./PopupRemind.vue?vue&type=script&lang=js"
export * from "./PopupRemind.vue?vue&type=script&lang=js"

import "./PopupRemind.vue?vue&type=style&index=0&id=67f8c4ff&scoped=true&lang=scss"

import exportComponent from "/data/jenkins/workspace/yh-node-yh-mallrobot-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67f8c4ff"]])

export default __exports__